import {
  ArrowBack,
  ArrowForward,
  BookOutlined,
  CheckCircleOutline,
  EmojiEventsOutlined,
  TrendingUp,
} from '@mui/icons-material';
import {
  Card,
  CardContent,
  LinearProgress,
  Typography,
  Box,
  lighten,
  useTheme,
  darken,
  Button,
  Chip,
  Pagination,
} from '@mui/material';
import CourseCard from './CourseCard';
import { useState } from 'react';
import courses from './courses.json';

const myCourses = [
  {
    id: '1',
    completedLessons: 5,
  },
  {
    id: '2',
    completedLessons: 12,
  },
];

export default function LearningPage() {
  const theme = useTheme();
  const [view, setView] = useState('subscribed');
  const [category, setCategory] = useState('Alle');
  const [explorePage, setExplorePage] = useState(1);

  const exploreCourses = courses.filter(
    (course) =>
      (category === 'Alle' || course.category === category) &&
      myCourses.every((myCourse) => myCourse.id !== course.id),
  );

  const myCoursesDetailed = myCourses.map((myCourse) => {
    const course = courses.find((c) => c.id === myCourse.id);
    return {
      ...course,
      completedLessons: myCourse.completedLessons,
    };
  });

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        py: 3,
      }}
    >
      <Card sx={{ maxWidth: '90%', width: '800px' }}>
        <CardContent>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                Willkommen zurück 👋
              </Typography>
              <Typography variant="body2">Bereit weiter zu lernen?</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                ml: 'auto',
                alignItems: 'center',
                borderRadius: 2,
                px: 3,
                py: 1,
                background: `linear-gradient(-45deg, ${lighten(theme.palette.primary.main, 0.1)} 10%, ${darken(theme.palette.primary.main, 0.1)} 90%)`,
              }}
            >
              <EmojiEventsOutlined
                sx={{ fontSize: 40, color: 'white', my: 1 }}
              />
              <Typography variant="h6" sx={{ color: 'white' }}>
                Level 12
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: 'rgba(255, 255, 255, 0.7)' }}
              >
                1500 XP
              </Typography>
            </Box>
          </Box>
          <Typography variant="body2" color="text.secondary">
            Dir fehlen noch 500 XP bis zum nächsten Level!
          </Typography>
          <LinearProgress sx={{ mt: 2 }} variant="determinate" value={45} />
        </CardContent>
      </Card>
      <Box
        sx={{ maxWidth: '90%', width: '800px', mt: 2, display: 'flex', gap: 2 }}
      >
        <Card
          sx={{
            flex: 1,
            p: 2,
            flexFlow: 'row',
            display: 'flex',
            gap: 2,
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: '60px',
              height: '60px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: theme.palette.hover.main,
              borderRadius: '8px',
            }}
          >
            <BookOutlined />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ lineHeight: 1.1 }}>
              2
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Aktive Kurse
            </Typography>
          </Box>
        </Card>
        <Card
          sx={{
            flex: 1,
            p: 2,
            flexFlow: 'row',
            display: 'flex',
            gap: 2,
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: '60px',
              height: '60px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: theme.palette.hover.main,
              borderRadius: '8px',
            }}
          >
            <CheckCircleOutline />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ lineHeight: 1.1 }}>
              23
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Abgeschlossen
            </Typography>
          </Box>
        </Card>
        <Card
          sx={{
            flex: 1,
            p: 2,
            flexFlow: 'row',
            display: 'flex',
            gap: 2,
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: '60px',
              height: '60px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: theme.palette.hover.main,
              borderRadius: '8px',
            }}
          >
            <TrendingUp />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ lineHeight: 1.1 }}>
              7 Tage
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Lernstreak
            </Typography>
          </Box>
        </Card>
      </Box>
      {view === 'subscribed' && (
        <Box sx={{ maxWidth: '90%', width: '800px', mt: 3 }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 'bold', color: 'text.primary' }}
          >
            Kurse fortsetzen
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 3 }}>
            {myCoursesDetailed.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
            {myCoursesDetailed.length === 0 && (
              <Typography variant="body2" color="text.secondary">
                Du hast noch keine aktiven Kurse 😢
              </Typography>
            )}
          </Box>
          <Button
            fullWidth
            sx={{
              mt: 2,
              '& .MuiButton-endIcon .MuiSvgIcon-root': { fontSize: '16px' },
            }}
            endIcon={<ArrowForward />}
            onClick={() => setView('explore')}
          >
            Mehr entdecken!
          </Button>
        </Box>
      )}
      {view === 'explore' && (
        <Box sx={{ maxWidth: '90%', width: '800px', mt: 3 }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 'bold', color: 'text.primary' }}
          >
            Kurse entdecken
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, mt: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, flex: 1 }}>
              <Chip
                label="Alle"
                variant={category === 'Alle' ? 'filled' : 'outlined'}
                sx={{ borderRadius: 1, cursor: 'pointer' }}
                onClick={() => setCategory('Alle')}
              />
              <Chip
                label="JavaScript"
                variant={category === 'JavaScript' ? 'filled' : 'outlined'}
                sx={{ borderRadius: 1, cursor: 'pointer' }}
                onClick={() => setCategory('JavaScript')}
              />
              <Chip
                label="React"
                variant={category === 'React' ? 'filled' : 'outlined'}
                sx={{ borderRadius: 1, cursor: 'pointer' }}
                onClick={() => setCategory('React')}
              />
              <Chip
                label="CSS"
                variant={category === 'CSS' ? 'filled' : 'outlined'}
                sx={{ borderRadius: 1, cursor: 'pointer' }}
                onClick={() => setCategory('CSS')}
              />
              <Chip
                label="HTML"
                variant={category === 'HTML' ? 'filled' : 'outlined'}
                sx={{ borderRadius: 1, cursor: 'pointer' }}
                onClick={() => setCategory('HTML')}
              />
            </Box>
            <Pagination
              count={Math.ceil(exploreCourses.length / 4)}
              page={explorePage}
              onChange={(e, value) => setExplorePage(value)}
              color="primary"
              variant="outlined"
              shape="rounded"
              sx={{
                mr: "-3px"
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              mt: 3,
              flex: 1,
            }}
          >
            {exploreCourses.map((course) => (
              <CourseCard key={course.id} course={course} />
            )).slice((explorePage - 1) * 4, explorePage * 4)}
            {exploreCourses.length === 0 && (
              <Typography variant="body2" color="text.secondary">
                Keine Kurse gefunden
              </Typography>
            )}
          </Box>
          <Button
            fullWidth
            sx={{
              mt: 2,
              '& .MuiButton-startIcon .MuiSvgIcon-root': { fontSize: '16px' },
            }}
            startIcon={<ArrowBack />}
            onClick={() => setView('subscribed')}
          >
            Zurück zu den Kursen
          </Button>
        </Box>
      )}
    </Box>
  );
}
